import { render, staticRenderFns } from "./PostResearch.vue?vue&type=template&id=0c98c884&"
import script from "./PostResearch.vue?vue&type=script&lang=js&"
export * from "./PostResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports